module.exports = __webpack_public_path__ + "static/media/21.55213662.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/21.mp3
// module id = 497
// module chunks = 0